export const BUBBLE = 'bubble';
export const BUTTONROW = 'buttonRow';
export const IMAGE = 'image';
export const INPUT = 'input';
export const WHEEL = 'wheel';
